module.exports = __webpack_public_path__ + "img/2203.bbe25937.gif";